export default __webpack_public_path__ + "static/media/tfp-menu@3x.9452dab2.png";